import React from 'react'
import { FaIcon, faTruckRampCouchSolid } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useAlertForm } from '../AlertFormContext'
import {
  FieldsetSelect,
  Option,
} from '@/modules/settings/components/FieldsetSelect'
import Radio from '@/modules/drivers/shared/Radio'

const AlertObject = () => {
  const { t } = useLocalize()
  const {
    concerns,
    setConcerns,
    drivers,
    vehicles,
    setSelectedVehicleId,
    setSelectedDriverId,
    selectedDriverId,
    selectedVehicleId,
  } = useAlertForm()

  const driverOptions: Option[] = drivers.map((d) => {
    const label = `${d.surname ?? ''} ${d.name ?? ''}`.trim()
    return {
      key: d.id,
      label: label || String(d.id),
      value: String(d.id),
    }
  })

  const vehicleOptions: Option[] = vehicles.map((v) => ({
    key: v.id,
    label: v.registrationNumber || v.registryNumber || String(v.id),
    value: String(v.id),
  }))

  const driverEnabled = concerns === 'driver'
  const vehicleEnabled = concerns === 'vehicle'

  const handleDriverToggle = (next: boolean) => {
    if (next) {
      setConcerns('driver')
      setSelectedVehicleId('')
    } else {
      setConcerns(null)
      setSelectedDriverId('')
    }
  }

  const handleVehicleToggle = (next: boolean) => {
    if (next) {
      setConcerns('vehicle')
      setSelectedDriverId('')
    } else {
      setConcerns(null)
      setSelectedVehicleId('')
    }
  }

  return (
    <div className="tw-flex tw-gap-2">
      <div className="tw-jusit tw-flex tw-max-w-[200px] tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faTruckRampCouchSolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          Obiekt
        </p>
      </div>

      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <div className="tw-flex tw-flex-col tw-gap-2">
          <div className="tw-flex tw-items-center tw-gap-2">
            <Radio
              checked={driverEnabled}
              onClick={() => handleDriverToggle(!driverEnabled)}
              onChange={() => {}}
            />
            <label className="tw-m-0 tw-text-sm tw-font-medium tw-text-content-base">
              {t('common.driver')}
            </label>
          </div>
          {driverEnabled && (
            <FieldsetSelect
              value={selectedDriverId}
              options={driverOptions}
              handleChange={(value) => setSelectedDriverId(value)}
              name="driver"
              placeholder={t('operation.find')}
            />
          )}
        </div>

        <div className="tw-flex tw-flex-col tw-gap-2">
          <div className="tw-flex tw-items-center tw-gap-2">
            <Radio
              checked={vehicleEnabled}
              onClick={() => handleVehicleToggle(!vehicleEnabled)}
              onChange={() => {}}
            />
            <label className="tw-m-0 tw-text-sm tw-font-medium tw-text-content-base">
              {t('common.vehicle')}
            </label>
          </div>
          {vehicleEnabled && (
            <FieldsetSelect
              value={selectedVehicleId}
              options={vehicleOptions}
              handleChange={(value) => setSelectedVehicleId(value)}
              name="vehicle"
              placeholder={t('operation.find')}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default AlertObject
